module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('media.description')))]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "gallery"
  }, [_vm._l((this.photos), function(photo, index) {
    return _c('div', {
      key: index,
      attrs: {
        "data-aos": "fade-up",
        "data-aos-delay": 100
      }
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": photo.source_url
      },
      on: {
        "click": function($event) {
          _vm.openModal(index)
        }
      }
    })])
  }), _vm._v(" "), _c('vs-popup', {
    attrs: {
      "title": ((_vm.activeIndex + 1) + " / " + (_vm.photos.length)),
      "active": _vm.isModalOpen
    },
    on: {
      "update:active": function($event) {
        _vm.isModalOpen = $event
      }
    }
  }, [_c('div', {
    staticClass: "popup-inner"
  }, [_c('div', {
    staticClass: "gallery-popup"
  }, [_c('div', {
    staticClass: "popup-btn left",
    class: {
      disable: _vm.activeIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.changePhoto(_vm.activeIndex - 1)
      }
    }
  }, [_c('i', {
    staticClass: "chevron left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gallery-inner"
  }, _vm._l((_vm.photos), function(photo, index) {
    return _c('div', {
      key: index,
      class: _vm.getClass(index)
    }, [_c('img', {
      attrs: {
        "src": photo.source_url
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "popup-btn right",
    class: {
      disable: _vm.activeIndex === _vm.photos.length - 1
    },
    on: {
      "click": function($event) {
        _vm.changePhoto(_vm.activeIndex + 1)
      }
    }
  }, [_c('i', {
    staticClass: "chevron right"
  })])])])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae9d7ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaBox.vue
// module id = 274
// module chunks = 0